export class ImageConstants {
  static ciranetLogoImage: string = 'assets/images/CiraNetLogo.svg';
  static okImage: string = 'assets/images/ok16x16.png';
  static removeImage: string = 'assets/images/remove16x16.png';
  static passwordToggleImage: string = 'assets/images/password-toggle.png';
  static helpAccountImage: string = 'assets/images/tearoff.gif';
  static ccLogo: string = 'assets/images/CC.png';
  static poweredByCCLogo: string = 'assets/images/PoweredByCC.png';
  static paypalCCImage: string = 'assets/images/PayPalCCLink.png';
  static complianceEmptyStateImage: string =
    'assets/images/Compliance_EmptyState_Edited.svg';
}
